// extracted by mini-css-extract-plugin
module.exports = {"mockup":"i-share-mockup_mockup__3Hhtd","i-share-gif":"i-share-mockup_i-share-gif__2Lq4x","phone-mockup":"i-share-mockup_phone-mockup__Y7__0"};